module.exports = __webpack_public_path__ + "3ad3107e6055bcab7457c9614a0755b1.svg";